var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column profile-page-wrapper"
  }, [_c('div', {
    staticClass: "profile-page-inner pa-4 pa-md-6"
  }, [_c('div', {
    staticClass: "container profile-container"
  }, [_vm.userExist ? _c('div', [!_vm.editing_profile && !_vm.editing_settings ? _c('div', {
    staticClass: "profile-view"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-12 mb-4 mb-lg-0"
  }, [_c('v-card', {
    staticClass: "profile-card profile-sidebar elevation-0"
  }, [_c('div', {
    staticClass: "profile-avatar-section"
  }, [_c('div', {
    staticClass: "profile-avatar-wrapper"
  }, [_c('v-img', {
    staticClass: "profile-avatar",
    attrs: {
      "src": _vm.current_user_page_profile_url,
      "alt": "Profile Picture"
    }
  }), _vm.editable ? _c('v-btn', {
    staticClass: "profile-avatar-edit",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.handleChangeImage
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-camera")])], 1) : _vm._e()], 1), _c('h2', {
    staticClass: "profile-username",
    on: {
      "click": _vm.handleShareProfileClick
    }
  }, [_vm._v(" " + _vm._s(_vm.username_param) + " "), _c('v-icon', {
    staticClass: "profile-share-icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-share-variant")])], 1), _vm.institution ? _c('p', {
    staticClass: "profile-institution"
  }, [_vm._v(_vm._s(_vm.institution))]) : _vm._e(), _vm.email ? _c('a', {
    staticClass: "profile-contact-link",
    attrs: {
      "href": 'mailto:' + _vm.email,
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-email-outline")]), _vm._v(" Contact ")], 1) : _vm._e()]), _vm.editable ? _c('div', {
    staticClass: "profile-actions"
  }, [_c('v-btn', {
    staticClass: "profile-action-btn mb-2",
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": _vm.handleEditProfile
    }
  }, [_vm._v(" Edit Profile ")]), _c('v-btn', {
    staticClass: "profile-action-btn mb-0",
    attrs: {
      "block": "",
      "outlined": ""
    },
    on: {
      "click": _vm.handleEditSettings
    }
  }, [_vm._v(" Settings ")])], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "col-lg-8 col-12"
  }, [_c('v-card', {
    staticClass: "profile-card profile-details elevation-0"
  }, [_c('v-card-title', {
    staticClass: "profile-details-title"
  }, [_vm._v("Profile Information")]), _c('v-card-text', {
    staticClass: "profile-details-content"
  }, [_c('div', {
    staticClass: "profile-info-row"
  }, [_c('span', {
    staticClass: "profile-info-label"
  }, [_c('v-icon', {
    staticClass: "profile-info-icon",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-account")]), _vm._v(" Full Name ")], 1), _c('span', {
    staticClass: "profile-info-value"
  }, [_vm._v(_vm._s(_vm.first_name) + " " + _vm._s(_vm.last_name))])]), _vm.profession ? _c('div', {
    staticClass: "profile-info-row"
  }, [_c('span', {
    staticClass: "profile-info-label"
  }, [_c('v-icon', {
    staticClass: "profile-info-icon",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-briefcase-outline")]), _vm._v(" Profession ")], 1), _c('span', {
    staticClass: "profile-info-value"
  }, [_vm._v(_vm._s(_vm.profession))])]) : _vm._e(), _vm.website ? _c('div', {
    staticClass: "profile-info-row"
  }, [_c('span', {
    staticClass: "profile-info-label"
  }, [_c('v-icon', {
    staticClass: "profile-info-icon",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-web")]), _vm._v(" Website ")], 1), _c('a', {
    staticClass: "profile-info-link",
    attrs: {
      "href": _vm.websiteHref,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.website))])]) : _vm._e(), _vm.reason_of_use ? _c('div', {
    staticClass: "profile-info-row"
  }, [_c('span', {
    staticClass: "profile-info-label"
  }, [_c('v-icon', {
    staticClass: "profile-info-icon",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-information-outline")]), _vm._v(" Reason of use ")], 1), _c('span', {
    staticClass: "profile-info-value"
  }, [_vm._v(_vm._s(_vm.reason_of_use))])]) : _vm._e(), _vm.country ? _c('div', {
    staticClass: "profile-info-row"
  }, [_c('span', {
    staticClass: "profile-info-label"
  }, [_c('v-icon', {
    staticClass: "profile-info-icon",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-map-marker-outline")]), _vm._v(" Country ")], 1), _c('span', {
    staticClass: "profile-info-value"
  }, [_vm._v(_vm._s(_vm.country))])]) : _vm._e()])], 1)], 1)])]) : _vm.editing_profile ? _c('div', {
    staticClass: "profile-edit-view"
  }, [_c('v-card', {
    staticClass: "profile-card profile-edit-card elevation-0"
  }, [_c('v-card-title', {
    staticClass: "profile-edit-title"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-pencil")]), _vm._v(" Edit Profile ")], 1), _c('v-card-text', [_c('ValidationObserver', {
    ref: "observer",
    staticClass: "d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var invalid = _ref.invalid;
        return [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Edit"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Username",
                  "readonly": true,
                  "disabled": true,
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.username,
                  callback: function ($$v) {
                    _vm.username = $$v;
                  },
                  expression: "username"
                }
              })];
            }
          }], null, true)
        })], 1)])]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "First name"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "First name",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.first_name,
                  callback: function ($$v) {
                    _vm.first_name = $$v;
                  },
                  expression: "first_name"
                }
              })];
            }
          }], null, true)
        })], 1)]), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Last name"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var errors = _ref4.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Last name",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.last_name,
                  callback: function ($$v) {
                    _vm.last_name = $$v;
                  },
                  expression: "last_name"
                }
              })];
            }
          }], null, true)
        })], 1)])]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required|email",
            "vid": "emailField",
            "name": "Email"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref5) {
              var errors = _ref5.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Email (will be used for two-factor authentication)",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v;
                  },
                  expression: "email"
                }
              })];
            }
          }], null, true)
        })], 1)])]), _vm.email !== _vm.original_email ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required|confirmed:emailField",
            "name": "Confirm Email"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref6) {
              var errors = _ref6.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Confirm new email",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                on: {
                  "paste": function ($event) {
                    $event.preventDefault();
                  }
                },
                model: {
                  value: _vm.confirm_email,
                  callback: function ($$v) {
                    _vm.confirm_email = $$v;
                  },
                  expression: "confirm_email"
                }
              })];
            }
          }], null, true)
        })], 1)])]) : _vm._e(), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('country-dropdown', {
          ref: "vcd",
          attrs: {
            "preferredCountries": ['US'],
            "defaultCountry": _vm.countryCode,
            "immediateCallSelectEvent": true,
            "enabledFlags": true,
            "enabledCountryCode": false,
            "showNameInput": true
          },
          on: {
            "onSelect": _vm.onSelectCountry
          }
        })], 1)]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6 pb-2"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Institution"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref7) {
              var errors = _ref7.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Institution",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.institution,
                  callback: function ($$v) {
                    _vm.institution = $$v;
                  },
                  expression: "institution"
                }
              })];
            }
          }], null, true)
        })], 1)]), _c('div', {
          staticClass: "col-md-6 pb-2"
        }, [_c('div', {
          staticClass: "form-outline"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Profession"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref8) {
              var errors = _ref8.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Profession",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.profession,
                  callback: function ($$v) {
                    _vm.profession = $$v;
                  },
                  expression: "profession"
                }
              })];
            }
          }], null, true)
        })], 1)])]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required",
            "name": "Reason"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref9) {
              var errors = _ref9.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Reason for use",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.reason_of_use,
                  callback: function ($$v) {
                    _vm.reason_of_use = $$v;
                  },
                  expression: "reason_of_use"
                }
              })];
            }
          }], null, true)
        })], 1)]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('ValidationProvider', {
          attrs: {
            "name": "Website"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref0) {
              var errors = _ref0.errors;
              return [_c('v-text-field', {
                staticClass: "ma-0",
                attrs: {
                  "label": "Website",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.website,
                  callback: function ($$v) {
                    _vm.website = $$v;
                  },
                  expression: "website"
                }
              })];
            }
          }], null, true)
        })], 1)]), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('v-checkbox', {
          attrs: {
            "label": "Sign up to receive our newsletter"
          },
          model: {
            value: _vm.newsletter,
            callback: function ($$v) {
              _vm.newsletter = $$v;
            },
            expression: "newsletter"
          }
        })], 1)]), _c('div', {
          staticClass: "profile-edit-actions"
        }, [_c('router-link', {
          staticClass: "profile-edit-discard",
          attrs: {
            "to": {
              name: 'ProfilePage',
              params: {
                username: _vm.username_param
              }
            }
          },
          nativeOn: {
            "click": function ($event) {
              return _vm.handleDiscard.apply(null, arguments);
            }
          }
        }, [_vm._v(" Discard ")]), _c('v-btn', {
          attrs: {
            "type": "submit",
            "outlined": "",
            "disabled": _vm.submitted && invalid || _vm.loading,
            "loading": _vm.loading
          },
          on: {
            "click": function ($event) {
              return _vm.onChangeProfile();
            }
          }
        }, [_vm._v(" Save Changes ")])], 1)];
      }
    }], null, false, 1808565048)
  })], 1)], 1)], 1) : _vm.editing_settings ? _c('div', {
    staticClass: "profile-settings-view"
  }, [_c('v-card', {
    staticClass: "profile-card profile-settings-card elevation-0"
  }, [_c('v-card-title', {
    staticClass: "profile-settings-title"
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cog")]), _vm._v(" Settings ")], 1), _c('v-card-text', [_c('div', {
    staticClass: "profile-settings-section"
  }, [_c('v-switch', {
    staticClass: "profile-settings-switch",
    attrs: {
      "label": "Enable Voice Auditory Feedback",
      "hint": "Audio updates for start and completion events",
      "persistent-hint": "",
      "color": "primary"
    },
    on: {
      "change": _vm.updateLocalStorage
    },
    model: {
      value: _vm.isAuditoryFeedbackEnabled,
      callback: function ($$v) {
        _vm.isAuditoryFeedbackEnabled = $$v;
      },
      expression: "isAuditoryFeedbackEnabled"
    }
  })], 1), _c('v-divider', {
    staticClass: "my-4"
  }), _c('div', {
    staticClass: "profile-settings-section profile-settings-danger"
  }, [_c('p', {
    staticClass: "profile-settings-warning"
  }, [_vm._v(" Remove your account and all associated data. This includes every session, trial, subject, and result that you have ever created. This process is irreversible. ")]), _vm.editable ? _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "outlined": "",
      "color": "error"
    },
    on: {
      "click": _vm.handleOpenDeleteAccount
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-delete-outline")]), _vm._v(" Delete Account ")], 1) : _vm._e()], 1), _c('router-link', {
    staticClass: "profile-settings-back",
    attrs: {
      "to": {
        name: 'ProfilePage',
        params: {
          username: _vm.username_param
        }
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleFinished.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to Profile ")], 1)], 1)], 1)], 1) : _vm._e(), _vm.deletingAccount ? _c('div', {
    staticClass: "profile-popup",
    on: {
      "click": _vm.handleDiscardDeleteAccount
    }
  }, [_c('div', {
    staticClass: "profile-popup-content profile-popup-danger",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "profile-popup-header"
  }, [_c('v-icon', {
    attrs: {
      "color": "error",
      "large": ""
    }
  }, [_vm._v("mdi-alert-circle-outline")]), _c('h2', {
    staticClass: "profile-popup-title"
  }, [_vm._v("Delete Account")])], 1), _vm._m(0), _c('p', {
    staticClass: "profile-popup-text"
  }, [_vm._v("Type your username below to confirm:")]), _c('ValidationProvider', {
    attrs: {
      "rules": "required",
      "name": "delete-user-confirm"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref1) {
        var errors = _ref1.errors;
        return [_c('v-text-field', {
          staticClass: "mb-3",
          attrs: {
            "label": "Username",
            "outlined": "",
            "dense": "",
            "error": errors.length > 0,
            "error-messages": errors[0]
          },
          model: {
            value: _vm.confirm_username,
            callback: function ($$v) {
              _vm.confirm_username = $$v;
            },
            expression: "confirm_username"
          }
        })];
      }
    }], null, false, 320338899)
  }), _c('div', {
    staticClass: "profile-popup-actions"
  }, [_c('v-btn', {
    attrs: {
      "color": "error",
      "disabled": _vm.confirm_username !== _vm.username_param
    },
    on: {
      "click": _vm.handleDeleteAccount
    }
  }, [_vm._v(" Delete Account ")]), _c('span', {
    staticClass: "profile-popup-cancel",
    on: {
      "click": _vm.handleDiscardDeleteAccount
    }
  }, [_vm._v("Cancel")])], 1)], 1)]) : _vm._e(), _vm.changingImage ? _c('div', {
    staticClass: "profile-popup",
    on: {
      "click": _vm.handleDiscard
    }
  }, [_c('div', {
    staticClass: "profile-popup-content",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "profile-popup-header"
  }, [_c('h2', {
    staticClass: "profile-popup-title"
  }, [_vm._v("Change Profile Photo")]), _c('v-btn', {
    staticClass: "profile-popup-close",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleDiscard
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "profile-image-upload-area"
  }, [_vm.selectedImage ? _c('v-img', {
    staticClass: "profile-image-preview",
    attrs: {
      "src": _vm.selectedImage,
      "alt": "Preview"
    }
  }) : _c('div', {
    staticClass: "profile-image-placeholder"
  }, [_c('v-icon', {
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-account-circle")]), _c('span', [_vm._v("No image selected")])], 1)], 1), _c('input', {
    ref: "fileInput",
    staticClass: "profile-file-input",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleImageUploaded
    }
  }), _c('v-btn', {
    staticClass: "mb-2 profile-choose-image-btn",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-upload")]), _vm._v(" Choose Image ")], 1), _c('div', {
    staticClass: "profile-popup-actions"
  }, [_c('span', {
    staticClass: "profile-popup-cancel",
    on: {
      "click": _vm.handleDiscard
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "loading": _vm.loading,
      "disabled": !_vm.selectedImage
    },
    on: {
      "click": _vm.handleSaveImage
    }
  }, [_vm._v(" Save ")])], 1)], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "profile-not-found"
  }, [_c('v-card', {
    staticClass: "profile-card elevation-0"
  }, [_c('v-card-text', {
    staticClass: "text-center py-8"
  }, [_c('v-icon', {
    staticClass: "mb-4",
    attrs: {
      "size": "64",
      "color": "grey"
    }
  }, [_vm._v("mdi-account-off-outline")]), _c('p', {
    staticClass: "text-h6 mb-0"
  }, [_vm._v("User \"" + _vm._s(_vm.username_param) + "\" not found")])], 1)], 1)], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "profile-popup-text"
  }, [_c('strong', {
    staticClass: "error--text"
  }, [_vm._v("WARNING:")]), _vm._v(" This action will permanently remove your account and all associated data, including every session, trial, subject, and result you have ever created. This process is irreversible. ")]);

}]

export { render, staticRenderFns }